import React from "react";
import { Layout } from "../../layouts/Layout";
import { StandardsDetailsFaq } from "../../components/StandardsDetails/StandardsDetailsFaq";
import {
  SD_WORKING_IMG01,
  SD_WORKING_IMG02,
  SERVICES_DETAILS02,
} from "../../lib/assets"

import { ServicesDetailsSidebar } from "../../components/ServicesDetails/ServicesDetailsSidebar";
import { StandardsDetailsWrapper } from "../../components/StandardsDetails/StandardsDetailsWrapper";
import { StandardsDetailsSidebar } from "../../components/StandardsDetails/StandardsDetailsSidebar";

const Standards = () => {
  return (
    <Layout footer = {2} breadcrumb={"ISO Standards"} title={"ISO Standards"}>
      {/* services-details-area */}
      <StandardsDetailsWrapper>
        <div className="services-details-wrap">
          <div className="services-details-content">
            <h2 className="title">
            ISO Standards: Driving Excellence in Management Systems

            </h2>
            <p>
            In today’s increasingly competitive and sustainability-driven business landscape, organizations 
            face the dual challenge of meeting high customer expectations while also adhering to 
            environmental and operational benchmarks. This requires more than just innovative products or
            efficient services—it demands a commitment to excellence, accountability, and continual 
            improvement. Adherence to internationally recognized standards, such as those set by the 
            International Organization for Standardization (ISO), has emerged as a cornerstone for 
            achieving these goals.
            <br/>
            <br/>
            ISO standards serve as comprehensive frameworks designed to address critical areas of 
            organizational performance. By aligning their operations with these standards, businesses 
            can consistently deliver high-quality products and services, minimize their environmental 
            impact, and demonstrate operational competence and integrity. This alignment not only enhances 
            credibility but also positions organizations as leaders in their respective industries.
            <br/>
            <br/>
          
            </p>
            <div className="company-benefit-wrap">
            
              {/* faq accordion */}
              <StandardsDetailsFaq />
            </div>
          </div>
        </div>
      </StandardsDetailsWrapper>

     
    </Layout>
  );
};

export default Standards;
